export const displayLvzSpecificDetailPanelSelector = ({displayLvzSpecificDetailPanel}) => displayLvzSpecificDetailPanel